import { computed, reactive } from 'vue'

/**
 * 列表页的搜索、筛选、排序：rows 是 ref(null | 数组)，null 表示还没加载。
 * @template T
 * @param {{ value: T[] | null }} rows
 * @param {{
 *   text: (row: T) => string,
 *   filters?: { key: string, label: string, options: { value: string, label: string }[], match: (row: T, value: string) => boolean }[],
 *   sorts?: { value: string, label: string, compare: (a: T, b: T) => number }[],
 * }} spec 排序第一项是默认顺序；不传 sorts 就没有排序框
 */
export function useListView(rows, { text, filters = [], sorts = [] }) {
  const state = reactive({ search: '', filters: Object.fromEntries(filters.map((filter) => [filter.key, ''])), sort: sorts.length === 0 ? '' : sorts[0].value })
  const shown = computed(() => {
    const needle = state.search.trim().toLowerCase()
    const matched = rows.value.filter((row) => (needle === '' || text(row).toLowerCase().includes(needle))
      && filters.every((filter) => state.filters[filter.key] === '' || filter.match(row, state.filters[filter.key])))
    return sorts.length === 0 ? matched : matched.toSorted(sorts.find((sort) => sort.value === state.sort).compare)
  })
  return { state, filters, sorts, shown }
}
